import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrioritatiComponent } from './prioritati.component';
import { AddPrioritatiComponent } from './add-prioritati/add-prioritati.component';
import { EditPrioritatiComponent } from './edit-prioritati/edit-prioritati.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        PrioritatiComponent,
        AddPrioritatiComponent,
        EditPrioritatiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [PrioritatiComponent]
})
export class PrioritatiModule { }
